import React from 'react'
import Select from "react-select";

const errorSelectStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        "&:hover": {
            borderColor: state.selectProps.hasError ? "#dc3545" : base.borderColor,
        },
    }),
};

const CostAllocation = ({ title = "Cost Allocation", rows = [], onChange, errors = {} ,isDisabled}) => {
    return (
        <>
            <div className="table-title mt-4">
                <h3>{title}</h3>
            </div>
            <div className="cost-allocation-list member-list">
                <div className="content-section">
                    {/* Left Table */}
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Cert Number</th>
                                    <th>Item Code</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row) => {
                                    const hasError = Boolean(errors[row.id]);
                                    return (
                                        <tr key={row.id}>
                                            <td>{row.label} <span className="text-danger">*</span></td>

                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.value}
                                                        options={row.options}
                                                        onChange={(selected) => onChange?.(row.id, selected)}
                                                        isMulti={row.isMultiSelect ?? false}
                                                        placeholder={row.placeholder ?? "Select"}
                                                        styles={errorSelectStyles}
                                                        hasError={hasError}
                                                        isDisabled={isDisabled}
                                                    />
                                                    {hasError && (
                                                        <div className="field-error text-danger" style={{ fontSize: "12px", marginTop: "2px" }}>
                                                            {errors[row.id]}
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}

                                {rows.length === 0 && (
                                    <tr>
                                        <td colSpan={2}>No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CostAllocation